import styled from 'styled-components';

export const Icon = styled.img`
    height: 40px;
    width: 40px;
    margin-right: 8px;
`;
